module.exports = __webpack_public_path__ + "img/ITW_Windzonen_Niederlande.00c2951b.svg";